import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

export const rutaTesoreria = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/tesoreria',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/tesoreria/PaginaTesoreria.js'), 'PaginaTesoreria'),
});
